module.exports = __webpack_public_path__ + "static/media/2.6ef745f5.mp3";